<template>
  <div class="bloc-player-auto-external-embed scroll-step js-scroll-show" ref="section">
    <div class="bloc-player-auto-external-embed__player" ref="playerWrapper">
      <div v-if="portrait && content.video_id_portrait" ref="playerDOMPortrait" class="bloc-video__video video-portrait" :data-plyr-provider="content.video_provider" :data-plyr-embed-id="content.video_id_portrait" :data-poster="require(`@/${content.poster_portrait}`)"></div>
      <div v-else-if="!portrait && content.video_id_landscape" ref="playerDOMLandscape" class="bloc-video__video video-landscape" :data-plyr-provider="content.video_provider" :data-plyr-embed-id="content.video_id_landscape" :data-poster="require(`@/${content.poster_landscape}`)"></div>
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr'
import config from '@/config';
import store from '@/store/store'

export default {
  name: 'PlayerAutoExternalEmbed',
  props: {
    content: {
      type: Object,
      required: true
    },
    forcePortrait: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      portrait: config.small || this.forcePortrait,
    }
  },
  mounted () {
     this.player = new Plyr((this.portrait ? this.$refs.playerDOMPortrait : this.$refs.playerDOMLandscape), {
      controls: [],
      autoplay: true,
      ratio: this.portrait ? '9:16' : '16:9',
      autopause: false,
      loop: {
        active: true,
      },
      muted: true,
      vimeo: { 
        muted: true,
      },
    })
    
    this.bind()
    this.resize()

    this.player.on('ready', this.play)
  },
  methods: {
    bind() {
      store.resize.listen(this.resize)
    },
    unbind () {
      store.resize.unlisten(this.resize)
      if (this.player) this.player.off('ready', this.play)
    },
    resize () {
      if (!this.$refs.playerWrapper) return
      const backgroundHeight = this.$refs.section.offsetHeight
      const backgroundWidth = this.$refs.section.offsetWidth

      let ratio = (backgroundWidth / backgroundHeight) * 100
      ratio = Math.round(ratio)
      ratio = ratio / 100

      if (!this.portrait) {
        if (ratio < 1.77) {
          this.$refs.playerWrapper.style.height = "100%"
          this.$refs.playerWrapper.style.width = `${Math.round(backgroundHeight * 1.78)}px`
        } else {
          this.$refs.playerWrapper.style.width = "100%"
          this.$refs.playerWrapper.style.height = `${Math.round(backgroundWidth / 1.78)}px`
        }
      } else {
        if (ratio < 0.55) {
          this.$refs.playerWrapper.style.height = "100%"
          this.$refs.playerWrapper.style.width = `${Math.round(backgroundHeight * 0.56)}px`
        } else {
          this.$refs.playerWrapper.style.width = "100%"
          this.$refs.playerWrapper.style.height = `${Math.round(backgroundWidth / 0.56)}px`
        }
      }
    },
    play () {
      this.player.volume = 0
      this.player.play()
    },
  },
  beforeUnmount () {
    this.player && this.player.destroy && this.player.destroy()
    this.unbind()
  }
}
</script>

<style lang="scss">
  .bloc-player-auto-external-embed {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;

    &__player {
      flex: none;
    }
  }
</style>
